<template>
  <div class="not-found">
    <div class="img-container">
      <img src="../assets/not-found/404@2X.png" alt="未找到资源" class="not-found-img" />
    </div>
    <div class="text-tip">啊咧！这儿的网页对你打了烊...</div>
    <div class="red-btn" @click="navigateToHome">返回首页</div>
  </div>
</template>

<script>
export default {
  methods: {
    navigateToHome() {
      this.$router.push(`/`);
    }
  }
};
</script>
<style lang="scss" scoped>
.not-found {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text-tip {
    margin: 10px 0;
    font-size: 24px;
    color: #000000;
  }
  .red-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 180px;
    height: 40px;
    border-radius: 12px;
    background-color: #df3445;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>
